import React from 'react';
import PropTypes from 'prop-types';

const NewHeart = ({ className, active = false, onClick = () => {} }) => (
  <svg
    width={27}
    height={25}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={`${className} ${active ? 'active' : ''}`}
    onClick={onClick}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M19.962 1c2.011 0 3.84.933 4.89 2.495.633.942 2.395 4.505-1.51 10.814-2.893 4.673-8.321 8.53-10.06 9.691-1.74-1.162-7.167-5.018-10.06-9.69C-.683 8 1.078 4.436 1.712 3.494 2.762 1.932 4.59 1 6.602 1c.156 0 .314.006.47.018 2.117.161 3.424 1.149 4.935 2.292.216.163.432.327.652.488l.623.46.622-.46c.22-.161.436-.325.652-.488 1.513-1.143 2.819-2.13 4.936-2.292a6.39 6.39 0 0 1 .47-.018Z"
      fill="#224251"
      fillOpacity={0.8}
      stroke="#fff"
    />
  </svg>
);

NewHeart.propTypes = {
  className: PropTypes.string,
  active: PropTypes.bool,
  onClick: PropTypes.func
};

export default NewHeart;
